module.exports = __webpack_public_path__ + "static/media/81.3cfb94f3.jpg";